import React, { Component } from "react";
import styled from "styled-components";

class ServiceIcon extends Component {
  render() {
    return (
      <Container mgn={this.props.mgn}>
        <Tag size={this.props.size}>{this.props.tag}</Tag>
      </Container>
    );
  }
}

const Container = styled.div`
  display: inline-block;
  background-color: #ffffff;
  padding: 0px 5px;
  margin: ${props => props.mgn || "0 5px 2px 0"};
`;

const Tag = styled.span`
  font-size: ${props => props.size || "12px"};
  text-transform: uppercase;
  line-height: ${props => props.size || "12px"};
  display: block;
  padding: 3px 0;
`;

export const PLUMBING = "plumbing";
export const DEMOLITION = "demolition";
export const CARPENTRY = "Carpentry / Joinery";
export const ELECTRICS = "Electrics";
export const PLASTERINGRENDERING = "Plastering / Rendering";
export const FLOORING = "Flooring";
export const DRYLINING = "Drylining";
export const PAINTINGDECORATING = "Painting  and decorating";
export const SUSPENDEDCEILINGS = "Suspended ceilings";
export const HANDYMAN = "Handyman  service";
export const PARTITIONWALLS = "Partition walls";
export const TILING = "tiling";

export default ServiceIcon;



// WEBPACK FOOTER //
// ./src/components/ServiceIcon.js